import styled from 'styled-components';

import media from 'apps/auth/theme/media';

export const ListItem = styled.li`
    padding: 4px;
    text-align: center;

    ${media.tablet720} {
        padding-left: 8px;
        padding-right: 8px;
    }
`;

export const ListItemTitle = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    cursor: ${(props) => (props.showInfo ? 'pointer' : 'default')};
`;
